module.exports = __webpack_public_path__ + "static/media/Eila.395f5d55.jpg";